export const ASSESSMENT_FEATURE_KEY = 'assessment';
